import React from 'react';
import { ActionIcon, Box, Button, Group, Stack, Text, Textarea, TextInput } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { BaseFieldProps } from './types';
import { ListItemType } from 'src/data-capture/types';

export function ListField<T extends Record<string, unknown>>({
  entityMetadata,
  fieldLabel,
  disabled,
  rightValue,
  form,
  formFieldName,
  variant,
  itemType,
  onChange,
}: BaseFieldProps<T> & { itemType: ListItemType }) {
  const inputProps = form.getInputProps(formFieldName);

  const renderListItem = () => {
    return (
      <Box id={formFieldName}>
        <Text mb={'md'} c={'gray.7'} size={'sm'} fw={500}>
          {fieldLabel}
        </Text>
        <Stack>
          {inputProps.defaultValue?.map((_: unknown, index: number) => {
            const itemFieldName = `${formFieldName}.${index}`;
            const listInputProps = form.getInputProps(itemFieldName);
            return (
              <Group key={index}>
                <ActionIcon
                  variant="transparent"
                  radius="xl"
                  aria-label="delete"
                  color={'black'}
                  mr={'md'}
                >
                  <IconTrash onClick={() => form.removeListItem(formFieldName, index)} />
                </ActionIcon>
                <Stack>
                  {itemType === 'STRING' ? (
                    <TextInput
                      required={!entityMetadata.isOptional}
                      labelProps={{ variant: 'light' }}
                      flex={1}
                      key={form.key(itemFieldName)}
                      aria-label="dynamic-list-item"
                      placeholder=""
                      disabled={disabled}
                      rightSection={rightValue}
                      {...listInputProps}
                      variant={variant}
                      onChange={value => onChange(value, itemFieldName)}
                    />
                  ) : (
                    <Textarea
                      required={!entityMetadata.isOptional}
                      labelProps={{ variant: 'light' }}
                      key={form.key(`${formFieldName}.${index}`)}
                      placeholder=""
                      disabled={disabled}
                      label={fieldLabel}
                      minRows={3}
                      autosize
                      resize="vertical"
                      {...listInputProps}
                      variant={variant}
                      onChange={value => onChange(value, itemFieldName)}
                    />
                  )}
                </Stack>
              </Group>
            );
          })}
        </Stack>
      </Box>
    );
  };

  return (
    <Stack>
      {renderListItem()}
      <Button
        onClick={() => {
          form.insertListItem(formFieldName, '');
        }}
      >
        Add
      </Button>
    </Stack>
  );
}
